import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NameService {
  public nameonDegree:string;
  public cnic:string;
  public isDegreeVerified:boolean;
  constructor() { }

  public setNameOnDegree(name):void{
    this.nameonDegree = name;
  }

  public getNameOnDegree(){
    return this.nameonDegree;
  }

  public setCNIC(cnic):void{
    this.cnic = cnic;
  }

  public getCNIC(){
    return this.cnic;
  }

  public setDegreeVerified(value){
    this.isDegreeVerified = value;
  }

  public getDegreeVerified(){
    return this.isDegreeVerified
  }
}
